export class ScanResponseInfo {

    fileName:string = "";
    scanned:boolean = false;
    clean:boolean = false;
    complete:boolean = false;
    message:string = "";
    threadName:string = "";
    elapsedTime:number ;
}
